var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14426 1.64789H10.6372C11.092 1.64789 11.4612 1.2787 11.4612 0.823947C11.4612 0.369191 11.092 0 10.6372 0H5.14426C4.6895 0 4.32031 0.369191 4.32031 0.823947C4.32031 1.2787 4.6895 1.64789 5.14426 1.64789Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84882 4.39448V13.4579C1.84882 14.9745 3.07874 16.2044 4.59531 16.2044H11.1869C12.7035 16.2044 13.9334 14.9745 13.9334 13.4579V4.39448H14.837C15.2479 4.39448 15.5813 4.02529 15.5813 3.57053C15.5813 3.11577 15.2479 2.74658 14.837 2.74658H0.945424C0.534549 2.74658 0.201172 3.11577 0.201172 3.57053C0.201172 4.02529 0.534549 4.39448 0.945424 4.39448H1.84907H1.84882ZM5.6939 6.31702V12.9086C5.6939 13.2118 5.93998 13.4579 6.2432 13.4579C6.54642 13.4579 6.7925 13.2118 6.7925 12.9086V6.31702C6.7925 6.0138 6.54642 5.76772 6.2432 5.76772C5.93998 5.76772 5.6939 6.0138 5.6939 6.31702ZM8.9897 6.31702V12.9086C8.9897 13.2118 9.23577 13.4579 9.53899 13.4579C9.84221 13.4579 10.0883 13.2118 10.0883 12.9086V6.31702C10.0883 6.0138 9.84221 5.76772 9.53899 5.76772C9.23577 5.76772 8.9897 6.0138 8.9897 6.31702Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBox);
export default __webpack_public_path__ + "static/media/trash-box.cb40977575ab3d89e8051f0451c8b5c8.svg";
export { ForwardRef as ReactComponent };